import * as React from 'react';
import { UIHeading4, UIText2 } from '@cian/ui-kit';

import * as styles from './styles.css';

interface IUserInfoProps {
  title: string;
  name: React.ReactNode;
  statuses: React.ReactNode[];
}

export const UserInfo = ({ title, statuses, name }: IUserInfoProps) => {
  return (
    <div className={styles['container']}>
      <div className={styles['title']}>
        <UIHeading4>{title}</UIHeading4>
      </div>
      <div className={styles['fieldset']}>
        <div className={styles['subtitle']}>
          <UIText2>Имя</UIText2>
        </div>
        <div className={styles['name']}>{name}</div>
      </div>
      <div className={styles['fieldset']}>
        <div className={styles['subtitle']}>
          <UIText2>Статус</UIText2>
        </div>
        <div className={styles['ratings']}>
          {statuses.map((status, i) => {
            return (
              <div key={i} className={styles['rating']}>
                {status}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
